import { ROUTE_NAMES } from '@atlassian/jira-common-constants/src/spa-routes';

export const globalSettingsSystemRolesActorsUsersRoute = {
	name: ROUTE_NAMES.GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS_USERS,
	path: '/secure/project/UserRoleActorAction.jspa',
};
